import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { EmailValidationPattern } from "./validateEmail";

/**
 * Custom validator to ensure that the "credit guard" service is will not regect the email
 */
export function customEmailFormValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    const emailForCreditGuardRegex = new RegExp(EmailValidationPattern).test(
      value
    );

    return !emailForCreditGuardRegex ? { emailIsNotValid: true } : null;
  };
}



// WEBPACK FOOTER //
// ./src/app/_helpers/customEmailFormValidator.ts